import React, { useState, useEffect } from 'react';
import {
  Box, Container, Typography, Card, CardContent, Button, Dialog, DialogTitle, DialogContent, 
  DialogActions, IconButton, Chip, Grid, CircularProgress, Paper, Divider, List, ListItem, 
  ListItemIcon, ListItemText, Table, TableBody, TableCell, TableContainer, TableRow, TableHead,
  ToggleButtonGroup, ToggleButton, Badge, Stack,TextField,InputAdornment,MenuItem,Select,FormControl,InputLabel,Alert,Collapse,Pagination
} from '@mui/material';
import {
  Close as CloseIcon, LocalHospital as ActivityIcon, Person as UserIcon, Phone as PhoneIcon,
  CalendarToday as CalendarIcon, Visibility as EyeIcon, Description as FileTextIcon,
  Notifications as BellIcon, Inventory as PackageIcon, CheckCircle as CheckCircleIcon,
  Cancel as XCircleIcon, Schedule as ClockIcon, Payment as PaymentIcon,
   ViewModule as ViewModuleIcon, ViewList as ViewListIcon,
  CloudUpload as UploadIcon, Download as DownloadIcon, Delete as DeleteIcon, InsertDriveFile as FileIcon,
  PictureAsPdf as PdfIcon, Image as ImageIcon, Description as DescriptionIcon, 
  Search as SearchIcon,  FilterList as FilterListIcon, Assignment as AssignmentIcon,LocalShipping as LocalShippingIcon,
  Edit as EditIcon, Save as SaveIcon,
} from '@mui/icons-material';
import CustomDialog from "../../CustomDialog";
import PersonIcon from '@mui/icons-material/Person';
import { apiRequest } from '../../fetchSetup';
import axios from 'axios';
import AssignAgent from './AssignAgent';
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PaymentPendingChip from '../OrderDetailsPage/PaymentPendingChip'; 
import { addUnseenOrder, isOrderUnseen, markOrderSeen,registerFetchedOrders} from '../../utils/orderNotifications';
// API Configuration
const WS_BASE_URL = process.env.REACT_APP_WS_BOOKINGS;
const UPLOAD_REPORT_API = process.env.REACT_APP_UPLOAD_DIAGNOSTIC_REPORT;
const DOWNLOAD_REPORT_API = process.env.REACT_APP_DOWNLOAD_DIAGNOSTIC_REPORT;
const DELETE_REPORT_API = process.env.REACT_APP_DELETE_DIAGNOSTIC_REPORT;
const UPDATE_BOOKINGS_API = process.env.REACT_APP_UPDATE_BOOKINGS;
const NOTIFICATION_API = process.env.REACT_APP_NOTIFICATION_API;
const GET_AGENT_API = process.env.REACT_APP_ASSGINED_DELIVERY_AGENT;
const GET_DIAGNOSTIC_BOOKINGS = process.env.REACT_APP_BOOKINGS;
const whatsappReportSend = process.env.REACT_APP_WHATSAPP_API_URL;


const normalizeBookingData = (booking) => {
  if (!booking) return null;
  
  let name = booking.name;
  if (!name || name === 'N/A') {
    name = booking.guest_name || booking.patient_name || 'N/A';
  }
  
  let email = booking.email;
  if (!email || email === 'N/A') {
    email = booking.guest_email || booking.patient_email || 'N/A';
  }
  
  let phone = booking.phone;
  if (!phone || phone === 'N/A') {
    phone = booking.guest_phone || booking.patient_phone || booking.mobile || 'N/A';
  }
  
  const age = booking.age || 'N/A';
  const gender = booking.gender || 'N/A';
  const diagnostic_tests = booking.diagnostic_tests || 'N/A';

  const payment = booking.payment ? {
    amount: booking.payment.amount || 0,
    status: booking.payment.status || 'pending',
    method: booking.payment.method || null,
    payment_id: booking.payment.payment_id || null,
    order_id: booking.payment.order_id || null,
    currency: booking.payment.currency || null,
    gateway: booking.payment.gateway || null,
    refund_id: booking.payment.refund_id || null,
    refund_amount: booking.payment.refund_amount || null,
    transaction_history: booking.payment.transaction_history || [],
  } : {
    amount: 0,
    status: 'pending',
    method: null,
    payment_id: null,
    transaction_history: [],
  };
  
  return {
    ...booking,  
    name,       
    email,       
    phone,    
    age,
    gender,
    diagnostic_tests,
    payment,
    diagnostic_reports: booking.diagnostic_reports || [],
  };
};

const DiagnosticOrdersScreen = () => {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState(null);
  const [customDialog, setCustomDialog] = useState({ show: false, message: '', title: '', type: 'success' });
  const [bookings, setBookings] = useState([]);
  const [wsConnected, setWsConnected] = useState(false);
  const [viewMode, setViewMode] = useState('card');
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] =  useState([]);
  const [filePreviewUrl, setFilePreviewUrl] = useState([]);
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [previewContent, setPreviewContent] = useState(null);
  const [agentDetails, setAgentDetails] = useState(null);
  const [loadingAgent, setLoadingAgent] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [activeTab, setActiveTab] = useState(0);
  const [reportDeliveryAgentDetails, setReportDeliveryAgentDetails] = useState(null);
  const [loadingReportAgent, setLoadingReportAgent] = useState(false);
  const [expandedIssues, setExpandedIssues] = useState({});
  const [searchInput, setSearchInput] = useState('');

  // ─── NEW: patient edit states ──────────────────────────────────────────────
  const [editingPatient, setEditingPatient] = useState(false);
  const [patientForm, setPatientForm] = useState({});
  const [savingPatient, setSavingPatient] = useState(false);
  // ──────────────────────────────────────────────────────────────────────────
  const [page, setPage] = useState(1);
  const [limit] = useState(21);
  const [totalPages, setTotalPages] = useState(1);
  const [totalBookings,setTotalBookings]=useState(0);
  const [communities, setCommunities] = useState([]);
  const [selectedCommunity, setSelectedCommunity]=useState("all")

  useEffect(() => {
    return () => {
      if (window.bookingWs) {
        window.bookingWs.close();
      }
      if (filePreviewUrl) {
        URL.revokeObjectURL(filePreviewUrl);
      }
    };
  }, []);

  useEffect(() => {
    return () => {
      if (filePreviewUrl) {
        URL.revokeObjectURL(filePreviewUrl);
      }
      if (previewContent?.url) {
        URL.revokeObjectURL(previewContent.url);
      }
    };
  }, [filePreviewUrl, previewContent]);

useEffect(() => {
  const local_communities=sessionStorage.getItem('communities')
  console.log(local_communities)
  setCommunities(JSON.parse(local_communities))
  fetchBookings(1, searchQuery);
  connectWebSocket();
}, []);
useEffect(() => {
  const delay = setTimeout(() => {
    // 🔥 reset to page 1 when searching
    fetchBookings(1, searchQuery);
  }, 400);

  return () => clearTimeout(delay);
}, [searchQuery]);

const fetchBookings = async (pageNumber = 1, searchValue = "") => {
  try {
    setLoading(true);

    const res = await fetch(
      `${GET_DIAGNOSTIC_BOOKINGS}/diagnostic-bookings?page=${pageNumber}&limit=${limit}&search=${searchValue}`
    );
    
    if (!res.ok) {
      throw new Error(`Server error: ${res.status}`);
    }

    const data = await res.json();

    setBookings(data.bookings);
    registerFetchedOrders('diagnostic', (data.bookings || []).map(b => ({ id: b.booking_id, status: b.status })));
    setTotalPages(data.total_pages);
    setPage(pageNumber);
    setTotalBookings(data.total);

  } catch (err) {
    showCustomDialog('Failed to load data',"error","Server Error");
    console.error("Fetch error:", err);
  } finally {
    setLoading(false);
  }
};



  const connectWebSocket = () => {
    setError(null);
    const token = sessionStorage.getItem("token");
    try {
      const ws = new WebSocket(`${WS_BASE_URL}?token=${token}`);

      ws.onopen = () => {
        console.log('WebSocket connected');
        setWsConnected(true);
      };

      ws.onmessage = (event) => {
          try {
            const message = JSON.parse(event.data);
            console.log("WS message:", message);

            switch (message.event) {

              case "BOOKING_CREATED": {
                setBookings(prev =>
                    prev.some(b => b.booking_id === message.booking.booking_id)
                      ? prev
                      : [message.booking, ...prev]
                  );
                  addUnseenOrder('diagnostic', message.booking.booking_id, message.booking.status);
                break;
              }

              case "BOOKING_UPDATED": {
                setBookings(prev =>
                  prev.map(b =>
                    b.booking_id === message.booking.booking_id
                      ? normalizeBookingData(message.booking)
                      : b
                  )
                );
                break;
              }
              default:
                console.warn("Unknown WS event:", message);
            }
            if (message.type=== "DIAGNOSTIC_REPORT_UPLOADED") {
              console.log(message)
              const today = new Date();
              const normalizedReports = message.reports.map(report => ({
                filename: report.filename,
                original_filename: report.original_filename,
                path: report.file_path, // 🔥 rename correctly
                uploaded_at: today, // fallback since WS doesn't send it
                uploaded_by: "staff", // or dynamic if you have it
                file_size: null, // optional
                storage_type: report.storage_type
              }));

  // ✅ Update selectedOrder safely
            setSelectedOrder(prev => {
              if (!prev || prev.booking_id !== message.booking_id) return prev;

              const existingFilenames = new Set(
                (prev.diagnostic_reports || []).map(r => r.filename)
              );

              const newReports = normalizedReports.filter(
                r => !existingFilenames.has(r.filename)
              );

              if (newReports.length === 0) return prev; // 🚀 nothing new

              return {
                ...prev,
                diagnostic_reports: [
                  ...(prev.diagnostic_reports || []),
                  ...newReports
                ]
              };
            });
              console.log("setting")
               setBookings(prev =>
                prev.map(booking => {
                  if (booking.booking_id !== message.booking_id) return booking;

                  const existingFilenames = new Set(
                    (booking.diagnostic_reports || []).map(r => r.filename)
                  );

                  const newReports = normalizedReports.filter(
                    r => !existingFilenames.has(r.filename)
                  );

                  if (newReports.length === 0) return booking; // 🚀 nothing new

                  return {
                    ...booking,
                    diagnostic_reports: [
                      ...(booking.diagnostic_reports || []),
                      ...newReports
                    ]
                  };
                })
              );
            }
          } catch (err) {
            console.error("Error parsing WS message:", err);
          }
        };

      ws.onerror = (error) => {
        console.error('WebSocket error:', error);
        setError('WebSocket connection error');
        setWsConnected(false);
      };

      ws.onclose = () => {
        console.log('WebSocket disconnected');
        setWsConnected(false);
        setTimeout(() => {
          console.log('Attempting to reconnect...');
          connectWebSocket();
        }, 5000);
      };

      window.bookingWs = ws;
    } catch (err) {
      console.error('Error connecting to WebSocket:', err);
      setError('Failed to connect to server');
    }
  };

  const getFileIcon = (fileName) => {
    if (!fileName || typeof fileName !== "string") {
      return <FileIcon sx={{ fontSize: 40, color: '#6B7280' }} />;
    }
  
    const parts = fileName.split(".");
    if (parts.length < 2) {
      return <FileIcon sx={{ fontSize: 40, color: '#6B7280' }} />;
    }
  
    const ext = parts.pop().toLowerCase();
  
    switch (ext) {
      case "pdf":
        return <PdfIcon sx={{ fontSize: 40, color: '#EF4444' }} />;
      case "png":
      case "jpg":
      case "jpeg":
        return <ImageIcon sx={{ fontSize: 40, color: '#3B82F6' }} />;
      case "doc":
      case "docx":
        return <DescriptionIcon sx={{ fontSize: 40, color: '#2563EB' }} />;
      default:
        return <FileIcon sx={{ fontSize: 40, color: '#6B7280' }} />;
    }
  };
  
  const isImageFile = (filename) => {
    const ext = filename.split('.').pop().toLowerCase();
    return ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(ext);
  };

  const isPdfFile = (filename) => {
    const ext = filename.split('.').pop().toLowerCase();
    return ext === 'pdf';
  };

  const handlePreviewFile = async (bookingId, report) => {
    let filename;
    
    try {
      filename = report.filename;
      const originalFilename = report.original_filename || report.filename;
      const cloudfrontUrl = report.cloudfront_url;
      const s3Key = report.s3_key;
  
      console.log('Preview request details:', {
        bookingId,
        filename,
        originalFilename,
        cloudfrontUrl,
        s3Key,
        report: report
      });
  
      if (cloudfrontUrl && cloudfrontUrl.includes('cloudfront.net')) {
        console.log('Opening CloudFront URL directly:', cloudfrontUrl);
        window.open(cloudfrontUrl, '_blank');
        return;
      }
  
      console.log(`Fetching from backend: ${DOWNLOAD_REPORT_API}/${bookingId}/${filename}`);
      
      const response = await apiRequest(`${DOWNLOAD_REPORT_API}/${bookingId}/${filename}`, {
        method: 'GET',
        credentials: 'include',
        redirect: 'manual'
      });
  
      if (response.status === 302 || response.status === 307) {
        const redirectUrl = response.headers.get('Location');
        console.log('Redirect URL found:', redirectUrl);
        
        if (redirectUrl) {
          window.open(redirectUrl, '_blank');
          return;
        }
      }
  
      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.status} ${response.statusText}`);
      }
  
      const blob = await response.blob();
      
      if (!blob || blob.size === 0) {
        throw new Error('Received empty file');
      }
  
      console.log(`Blob received: size=${blob.size}, type=${blob.type}`);
  
      const blobUrl = URL.createObjectURL(blob);
      const isImage = isImageFile(originalFilename);
      const isPdf = isPdfFile(originalFilename);
  
      setPreviewContent({
        url: blobUrl,
        type: blob.type,
        filename: originalFilename,
        isImage,
        isPdf
      });
  
      setPreviewFile({ ...report, bookingId });
      setPreviewDialogOpen(true);
  
    } catch (err) {
      console.error('Preview error:', err);
      
      if (filename) {
        const fallbackUrl = `${process.env.REACT_APP_MEDIA_CDN || "https://dhlkl2wv8e0dt.cloudfront.net"}/lab_reports/${bookingId}/${filename}`;
        console.log('Trying fallback URL:', fallbackUrl);
        
        showCustomDialog(
          `Cannot preview: ${err.message}. Trying direct link...`,
          'warning',
          'Preview Error'
        );
        
        setTimeout(() => {
          window.open(fallbackUrl, '_blank');
        }, 1000);
      } else {
        showCustomDialog(
          `Cannot preview: ${err.message}. Please try downloading the file instead.`,
          'error',
          'Preview Error'
        );
      }
    }
  };
  const handlePageChange = (newPage) => {
  fetchBookings(newPage, searchQuery);
};
  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    const maxSize = 10 * 1024 * 1024;
  
    const allowedTypes = [
      'image/png', 'image/jpeg', 'image/jpg', 'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ];
  
    const validFiles = [];
    const previews = [];
  
    for (const file of files) {
      if (!allowedTypes.includes(file.type)) {
        showCustomDialog(
          `${file.name} is not allowed. Please upload PNG, JPG, PDF, DOC, or DOCX files only.`,
          'error',
          'Invalid File'
        );
        continue;
      }
  
      if (file.size > maxSize) {
        showCustomDialog(
          `${file.name} exceeds 10MB. Choose a smaller file.`,
          'error',
          'File Too Large'
        );
        continue;
      }
  
      validFiles.push(file);
  
      if (file.type.startsWith('image/')) {
        previews.push(URL.createObjectURL(file));
      } else {
        previews.push(null);
      }
    }
  
    setSelectedFile(validFiles);
    setPreviewFile(previews);
  };

  const handleUploadReport = async () => {
    if (selectedFile.length === 0 || !selectedOrder) return;
  
    setUploading(true);
    const formData = new FormData();
  
    selectedFile.forEach(file => formData.append('file', file));
  
    try {
      const response = await apiRequest(`${UPLOAD_REPORT_API}/${selectedOrder.booking_id}`, {
        method: 'POST',
        body: formData
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to upload report');
      }
  
      const result = await response.json();
      showCustomDialog(result.message || 'Reports uploaded successfully!', 'success', 'Success');
  
      setSelectedFile([]);
      filePreviewUrl.forEach(url => url && URL.revokeObjectURL(url));
      setFilePreviewUrl([]);
  
      if (window.bookingWs?.readyState === WebSocket.OPEN) {
        window.bookingWs.send(JSON.stringify({ action: 'refresh' }));
      }
  
    } catch (err) {
      console.error('Upload report error:', err);
      showCustomDialog('Failed to upload report: ' + err.message, 'error', 'Error');
    } finally {
      setUploading(false);
    }
  };
  
  const handleDownloadReport = async (bookingId, filename) => {
    try {
      console.log("Download request:", { bookingId, filename });
  
      const response = await apiRequest(
        `${DOWNLOAD_REPORT_API}/${bookingId}/${filename}`,
        { method: "GET" }
      );
  
      if (!response.ok) {
        const errText = await response.text();
        throw new Error(errText || "Download failed");
      }
  
      const data = await response.json();
  
      if (data.download_url) {
        window.location.href = data.download_url;
        return;
      }
  
      if (data.file_url) {
        window.location.href = data.file_url;
        return;
      }
  
      throw new Error("Invalid download response from server");
  
    } catch (err) {
      console.error("Download error:", err);
      showCustomDialog(
        "Failed to download report: " + err.message,
        "error",
        "Error"
      );
    }
  };
  
  const handleDeleteReport = async (bookingId, filename) => {
    if (!window.confirm('Are you sure you want to delete this report?')) return;
  
    try {
      const response = await apiRequest(`${DELETE_REPORT_API}/${bookingId}/${filename}`, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
  
      console.log('Delete response status:', response.status);
      
      const contentType = response.headers.get('content-type');
      
      if (!response.ok) {
        let errorMessage = `Server error: ${response.status} ${response.statusText}`;
        
        if (contentType && contentType.includes('application/json')) {
          try {
            const errorData = await response.json();
            errorMessage = errorData.error || errorData.message || errorMessage;
          } catch (jsonErr) {
            console.error('Failed to parse error JSON:', jsonErr);
          }
        } else {
          const textResponse = await response.text();
          console.error('Non-JSON error response:', textResponse);
          
          if (textResponse.includes('DiagnosticReportDocument')) {
            errorMessage = 'Backend returned unexpected data. Please check server logs.';
          } else if (textResponse.length < 500) {
            errorMessage = `Server error: ${textResponse.substring(0, 100)}...`;
          }
        }
        
        throw new Error(errorMessage);
      }
  
      let result;
      if (contentType && contentType.includes('application/json')) {
        result = await response.json();
      } else {
        const textResponse = await response.text();
        console.log('Non-JSON success response:', textResponse);
        result = { message: 'Report deleted successfully!' };
      }
  
      showCustomDialog(result.message || 'Report deleted successfully!', 'success', 'Success');
      
      setSelectedOrder(prev => ({
        ...prev,
        diagnostic_reports: prev.diagnostic_reports.filter(r => r.filename !== filename)
      }));
      
      setBookings(prev => prev.map(booking => 
        booking.booking_id === bookingId
          ? { ...booking, diagnostic_reports: booking.diagnostic_reports.filter(r => r.filename !== filename) }
          : booking
      ));
      
      if (previewDialogOpen && previewFile?.filename === filename) {
        handleClosePreviewDialog();
      }
  
    } catch (err) {
      console.error('Delete report error:', err);
      
      let userMessage = err.message;
      if (err.message.includes('DiagnosticReportDocument') || err.message.includes('unexpected data')) {
        userMessage = 'Backend error: The server returned unexpected data. The report may have been deleted but there was an error in the response.';
      }
      
      showCustomDialog(`Failed to delete report: ${userMessage}`, 'error', 'Error');
    }
  };

  const fetchAgentDetails = async (agentId) => {
    if (!agentId) {
      setAgentDetails(null);
      return;
    }
    
    setLoadingAgent(true);
    try {
      const response = await apiRequest(`${GET_AGENT_API}/${agentId}`);
      if (response.ok) {
        const data = await response.json();
        console.log("✅ Agent details fetched:", data);
        setAgentDetails(data);
      } else {
        console.warn("⚠️ Agent not found");
        setAgentDetails(null);
      }
    } catch (error) {
      console.error("Error fetching agent details:", error);
      setAgentDetails(null);
    } finally {
      setLoadingAgent(false);
    }
  };
// ✅ ADD NEW FUNCTION for report delivery agent
const fetchReportDeliveryAgentDetails = async (agentId) => {
  if (!agentId) {
    setReportDeliveryAgentDetails(null);
    return;
  }
  
  setLoadingReportAgent(true);
  try {
    const response = await apiRequest(`${GET_AGENT_API}/${agentId}`);
    if (response.ok) {
      const data = await response.json();
      console.log("✅ Report delivery agent details fetched:", data);
      setReportDeliveryAgentDetails(data);
    } else {
      console.warn("⚠️ Report delivery agent not found");
      setReportDeliveryAgentDetails(null);
    }
  } catch (error) {
    console.error("Error fetching report delivery agent details:", error);
    setReportDeliveryAgentDetails(null);
  } finally {
    setLoadingReportAgent(false);
  }
};
  const handleOpenDialog = (order) => {
    console.log('🔵 handleOpenDialog called with:', order);
    markOrderSeen('diagnostic', order.booking_id);
    const normalizedOrder = normalizeBookingData(order);
    
    setSelectedOrder(normalizedOrder);
    
    setDialogOpen(true);
    setSelectedFile([]);
    setFilePreviewUrl([]);
    
    if (normalizedOrder.assigned_agent_id) {
      fetchAgentDetails(normalizedOrder.assigned_agent_id);
    }
     // ✅ Fetch report delivery agent
  if (normalizedOrder.report_delivery_agent_id) {
    fetchReportDeliveryAgentDetails(normalizedOrder.report_delivery_agent_id);
  }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedOrder(null);
    setSelectedFile([]);
    setAgentDetails(null); 
    setReportDeliveryAgentDetails(null);
    if (filePreviewUrl) {
      URL.revokeObjectURL(filePreviewUrl);
      setFilePreviewUrl([]);
    }
  };

  const handleClosePreviewDialog = () => {
    setPreviewDialogOpen(false);
    if (previewContent?.url) {
      URL.revokeObjectURL(previewContent.url);
    }
    setPreviewContent(null);
    setPreviewFile(null);
  };

  const showCustomDialog = (message, type = 'success', title = 'Notification') => {
    setCustomDialog({ show: true, message, type, title });
  };

  const handleCloseCustomDialog = () => {
    setCustomDialog({ show: false, message: '', type: 'success', title: '' });
  };

  const handleViewModeChange = (event, newViewMode) => {
    if (newViewMode !== null) {
      setViewMode(newViewMode);
    }
  };

  const getStatusConfig = (status) => {
    const configs = {
      new: { color: 'info', icon: <ClockIcon />, label: 'New' },
      Confirmed: { color: 'primary', icon: <CheckCircleIcon />, label: 'Confirmed' },
      'sample-collected': { color: 'warning', icon: <CheckCircleIcon />, label: 'Sample Collected' },
      'test-in-progress': { color: 'warning', icon: <ClockIcon />, label: 'Test In Progress' },
      'report-ready': { color: 'success', icon: <CheckCircleIcon />, label: 'Report Ready' },
      'report-packed': { color: 'warning', icon: <PackageIcon />, label: 'Report Packed' },
      'report-dispatched': { color: 'info', icon: <LocalShippingIcon />, label: 'Report Dispatched' },  
      'report-delivered': { color: 'success', icon: <CheckCircleIcon />, label: 'Report Delivered' },
      closed: { color: 'secondary', icon: <CheckCircleIcon />, label: 'Closed' },
      cancelled: { color: 'error', icon: <XCircleIcon />, label: 'Cancelled' },
      rescheduled: { color: 'secondary', icon: <CalendarIcon />, label: 'Rescheduled' }
    };
    return configs[status] || { color: 'default', icon: null, label: status };
  };

  const getPaymentStatusConfig = (status) => {
    const configs = {
      pending: { color: 'warning', label: 'Pending' },
      success: { color: 'success', label: 'Success' },
      failed: { color: 'error', label: 'Failed' },
      refunded: { color: 'info', label: 'Refunded' }
    };
    return configs[status] || { color: 'default', label: status };
  };

  const updateBooking = async (bookingId, action, data = {}) => {
    setUpdating(true);
    try {
      const payload = { action, ...data };
      
      const response = await apiRequest(`${UPDATE_BOOKINGS_API}/${bookingId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to update booking');
      }
      
      const result = await response.json();

      showCustomDialog(result.message || 'Booking updated successfully!', 'success', 'Success');
      
      if (selectedOrder && result.booking) {
        const extractedName = result.booking.name || result.booking.guest_name || selectedOrder.name;
        const extractedEmail = result.booking.email || result.booking.guest_email || selectedOrder.email;
        const extractedPhone = result.booking.phone || result.booking.guest_phone || selectedOrder.phone;
        
        const mergedBooking = {
          ...selectedOrder,    
          ...result.booking,  
          name: extractedName,
          email: extractedEmail,
          phone: extractedPhone,
          age: result.booking.age || selectedOrder.age,
          gender: result.booking.gender || selectedOrder.gender,
          diagnostic_tests: result.booking.diagnostic_tests || selectedOrder.diagnostic_tests,
          diagnostic_reports: result.booking.diagnostic_reports || selectedOrder.diagnostic_reports || [],
          payment: result.booking.payment || selectedOrder.payment,
        };
                
        const normalizedBooking = normalizeBookingData(mergedBooking);
                
        setSelectedOrder(normalizedBooking);
        
        setBookings(prev => prev.map(booking => {
          if (booking.booking_id === bookingId) {
            const bookingName = result.booking.name || result.booking.guest_name || booking.name;
            const bookingEmail = result.booking.email || result.booking.guest_email || booking.email;
            const bookingPhone = result.booking.phone || result.booking.guest_phone || booking.phone;
            
            return normalizeBookingData({
              ...booking,
              ...result.booking,
              name: bookingName,
              email: bookingEmail,
              phone: bookingPhone,
            });
          }
          return booking;
        }));
      }
      
      return result;
    } catch (err) {
      console.error('Update booking error:', err);
      showCustomDialog('Failed to update booking: ' + err.message, 'error', 'Error');
      throw err;
    } finally {
      setUpdating(false);
    }
  };
   const handleInvoiceDownload=async(order_id)=>{
      try {
            const token = sessionStorage.getItem("token");

            const response = await axios.get(
              `${process.env.REACT_APP_API_INVOICE}/diagnostic-invoice/download/${order_id}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            const download_url=response.data.download_url
            window.open(download_url, "_blank");
          } catch (error) {
            console.error("Invoice download failed:", error);
          }
}
      const sendDiagnosticReportOnWhatsapp=async()=>{
        let fileurl=""
        const report_url=selectedOrder.diagnostic_reports.map((report, idx) => {
        fileurl = report?.cloudfront_url || '';
                          
        })
        try {
        const resp= await axios.post(`${whatsappReportSend}api/flask/messages/send-diagnostic-report`, {
        phone: selectedOrder.phone,
        report_url:fileurl,
        name:selectedOrder.name
      });
        }
        catch (err){
          showCustomDialog('Failed to send Report: ', 'error', 'Error')
        }
      
      }
  const sendNotification = async () => {
    if (!selectedOrder) return;
    setUpdating(true);
    try {
      const response = await apiRequest(`${NOTIFICATION_API}/${selectedOrder.booking_id}`, { method: 'POST', headers: { 'Content-Type': 'application/json' } });
      if (!response.ok) { const err = await response.json(); throw new Error(err.error || 'Failed to send notification'); }
      const result = await response.json();
      showCustomDialog(result.message || `Notification sent to ${selectedOrder.email || selectedOrder.name}`, 'success', 'Notification Sent');
    } catch (err) { showCustomDialog('Failed to send notification: ' + err.message, 'error', 'Error'); }
    finally { setUpdating(false); }
  };

  // ─── NEW: save patient details ─────────────────────────────────────────────
  const handleStartEditPatient = () => {
    setPatientForm({
      name:   selectedOrder?.name   || '',
      email:  selectedOrder?.email  || '',
      phone:  selectedOrder?.phone  || '',
      age:    selectedOrder?.age    || '',
      gender: selectedOrder?.gender || '',
    });
    setEditingPatient(true);
  };

  const handleCancelEditPatient = () => {
    setEditingPatient(false);
    setPatientForm({});
  };

  const handleSavePatient = async () => {
    setSavingPatient(true);
    try {
      const response = await apiRequest(
        `${UPDATE_BOOKINGS_API}/${selectedOrder.booking_id}/patient-details`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ patient_details: patientForm }),
        }
      );

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.message || 'Failed to update patient details');
      }

      // Optimistic local update
      const updatedOrder = {
        ...selectedOrder,
        name:   patientForm.name   || selectedOrder.name,
        email:  patientForm.email  || selectedOrder.email,
        phone:  patientForm.phone  || selectedOrder.phone,
        age:    patientForm.age    || selectedOrder.age,
        gender: patientForm.gender || selectedOrder.gender,
      };
      setSelectedOrder(updatedOrder);
      setBookings(prev => prev.map(b => b.booking_id === selectedOrder.booking_id ? updatedOrder : b));

      setEditingPatient(false);
      setPatientForm({});
      showCustomDialog('Patient details updated successfully!', 'success', 'Saved');
    } catch (err) {
      showCustomDialog('Failed to save patient details: ' + err.message, 'error', 'Error');
    } finally {
      setSavingPatient(false);
    }
  };
  // ──────────────────────────────────────────────────────────────────────────

  const getFilteredBookings = () => {
    let filtered = [...bookings];

    // Filter by active tab
    if (activeTab === 1) {
      // Report Collected tab - only show report-ready status
      filtered = filtered.filter(booking => booking.status === 'report-ready');
    }

    // Apply status filter (only on All Orders tab)
    if (activeTab === 0 && statusFilter !== 'all') {
      filtered = filtered.filter(booking => booking.status === statusFilter);
    }
    if (activeTab === 0 && selectedCommunity !== 'all') {
      filtered = filtered.filter(booking => booking.address?.community_name === selectedCommunity);
    }
    return filtered;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-IN', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'grey.50' }}>
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress size={60} sx={{ mb: 2, color: '#006D77' }} />
          <Typography variant="h6" color="text.secondary">Loading Bookings..</Typography>
        </Box>
      </Box>
    );
  }



  const statusConfig = selectedOrder ? getStatusConfig(selectedOrder.status) : null;
  const paymentStatusConfig = selectedOrder?.payment ? getPaymentStatusConfig(selectedOrder.payment.status) : null;

  // Count report-ready bookings
  const reportReadyCount = bookings.filter(b => b.status === 'report-ready').length;






const getCombinedIssues = (booking) => {
  if (!booking) return [];
  
  const issues = [];
  // ========== ADD DELIVERY ISSUES ==========
  if (booking.delivery_issues && booking.delivery_issues.length > 0) {
    booking.delivery_issues.forEach(issue => {
      issues.push({
        ...issue,
        source: 'delivery_issue',
        issue_category: 'Delivery Issue'
      });
    });
  }
  // ========== ADD COLLECTION FAILURES ==========
  if (booking.collection_failures && booking.collection_failures.length > 0) {
    booking.collection_failures.forEach((failure, index) => {
      const issueId = failure.issue_id || `CF-${booking.booking_id}-${index}`;
      
      issues.push({
        issue_id: issueId,
        issue_type: failure.failure_type || failure.failureType,
        description: failure.failure_details || failure.failureDetails || 
                     `${failure.failure_reason || failure.failureReason}: ${failure.failure_details || failure.failureDetails || ''}`,
        reported_at: failure.reported_at || failure.reportedAt,
        reported_by: failure.reported_by || failure.reportedBy,
        status: failure.status || 'open',
        photo_url: failure.photo_url || null,
        source: 'collection_failure',
        issue_category: 'Sample Collection Failure',
        
        can_reschedule: failure.can_reschedule || failure.canReschedule,
        suggested_reschedule_time: failure.suggested_reschedule_time || failure.suggestedRescheduleTime,
        patient_available: failure.patient_available || failure.patientAvailable,
        address_issue: failure.address_issue || failure.addressIssue,
        additional_notes: failure.additional_notes || failure.additionalNotes
      });
    });
  }
  
  // Sort by reported_at (most recent first)
  issues.sort((a, b) => {
    const dateA = new Date(a.reported_at);
    const dateB = new Date(b.reported_at);
    return dateB - dateA;
  });
  
  return issues;
};


  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50' }}>
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Box>
            <Typography variant="h4" fontWeight="bold" color="#006D77" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <ActivityIcon sx={{ fontSize: 40 }} />
              Diagnostic Bookings
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage diagnostic test bookings and reports ({getFilteredBookings().length} of {totalBookings} bookings)
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <ToggleButtonGroup value={viewMode} exclusive onChange={handleViewModeChange} size="small">
              <ToggleButton value="card">
                <ViewModuleIcon sx={{ mr: 0.5 }} />
                Cards
              </ToggleButton>
              <ToggleButton value="table">
                <ViewListIcon sx={{ mr: 0.5 }} />
                Table
              </ToggleButton>
            </ToggleButtonGroup>
            <Chip 
              icon={wsConnected ? <CheckCircleIcon /> : <XCircleIcon />}
              label={wsConnected ? 'Connected' : 'Disconnected'}
              color={wsConnected ? 'success' : 'error'}
              size="small"
            />
          </Box>
        </Box>

        {/* Tab Navigation */}
        <Card sx={{ mb: 3 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <ToggleButtonGroup
              value={activeTab}
              exclusive
              onChange={(e, newValue) => {
                if (newValue !== null) {
                  setActiveTab(newValue);
                  setStatusFilter('all'); // Reset status filter when switching tabs
                }
              }}
              sx={{ width: '100%' }}
            >
              <ToggleButton 
                value={0} 
                sx={{ 
                  flex: 1,
                  py: 2,
                  textTransform: 'none',
                  fontSize: '16px',
                  fontWeight: activeTab === 0 ? 'bold' : 'normal',
                  color: activeTab === 0 ? '#006D77' : 'text.secondary',
                  '&.Mui-selected': {
                    bgcolor: 'rgba(0, 109, 119, 0.08)',
                    color: '#006D77',
                    '&:hover': {
                      bgcolor: 'rgba(0, 109, 119, 0.12)',
                    }
                  }
                }}
              >
                <PackageIcon sx={{ mr: 1 }} />
                All Orders
                <Chip 
                  label={totalBookings} 
                  size="small" 
                  sx={{ ml: 1, bgcolor: activeTab === 0 ? '#006D77' : 'grey.400', color: 'white' }}
                />
              </ToggleButton>
              <ToggleButton 
                value={1}
                sx={{ 
                  flex: 1,
                  py: 2,
                  textTransform: 'none',
                  fontSize: '16px',
                  fontWeight: activeTab === 1 ? 'bold' : 'normal',
                  color: activeTab === 1 ? '#006D77' : 'text.secondary',
                  '&.Mui-selected': {
                    bgcolor: 'rgba(0, 109, 119, 0.08)',
                    color: '#006D77',
                    '&:hover': {
                      bgcolor: 'rgba(0, 109, 119, 0.12)',
                    }
                  }
                }}
              >
                <AssignmentIcon sx={{ mr: 1 }} />
                Report Collected
                <Badge 
                  badgeContent={reportReadyCount} 
                  color="success"
                  sx={{ ml: 1 }}
                >
                  <Box />
                </Badge>
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Card>

        {/* Search and Filter Bar */}
        <Paper sx={{ p: 2, mb: 3, display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center', bgcolor: '#f8fafc' }}>
          <TextField
            placeholder="Search by Booking ID, Name, Phone..."
            variant="outlined"
            size="small"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setSearchQuery(searchInput);
                setPage(1);
              }
            }}
            sx={{ 
              flex: { xs: '1 1 100%', sm: '1 1 auto' },
              minWidth: { xs: '100%', sm: '350px' },
              '& .MuiOutlinedInput-root': {
                bgcolor: 'white'
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: '#006D77' }} />
                </InputAdornment>
              ),
            }}
          />
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                setSearchQuery(searchInput);
                setPage(1);
              }}
              sx={{
                bgcolor: '#006D77',
                '&:hover': {
                  bgcolor: '#005560',
                },
                minWidth: 70,
              }}
            >
              Search
            </Button>
             <FormControl size="small" sx={{ minWidth: 200 }}>
                        <InputLabel id="status-filter-label">
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <FilterListIcon fontSize="small" />
                            Filter by Community
                          </Box>
                        </InputLabel>
                        <Select
                          labelId="status-filter-label"
                          value={selectedCommunity}
                          label="Filter by Community"
                          onChange={(e) => {
                            setSelectedCommunity(e.target.value);
                            setPage(1); // Reset to first page on filter change
                          }}
                          sx={{ bgcolor: 'white' }}
                        >
                          <MenuItem value="all">Community</MenuItem>
                            {communities.map((community) => (
                              <MenuItem
                                key={community.name}
                                value={community.name}
                              >
                                {community.name}
                              </MenuItem>
                            ))}
            
                            </Select>
                      </FormControl>
          {/* Only show status filter on All Orders tab */}
          {activeTab === 0 && (
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel id="status-filter-label">
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <FilterListIcon fontSize="small" />
                  Filter by Status
                </Box>
              </InputLabel>
              <Select
                labelId="status-filter-label"
                value={statusFilter}
                label="Filter by Status"
                onChange={(e) => setStatusFilter(e.target.value)}
                sx={{ bgcolor: 'white' }}
              >
                <MenuItem value="all">All Statuses</MenuItem>
                <MenuItem value="new">New</MenuItem>
                <MenuItem value="Confirmed">Confirmed</MenuItem>
                <MenuItem value="sample-collected">Sample Collected</MenuItem>
                <MenuItem value="test-in-progress">Test In Progress</MenuItem>
                <MenuItem value="report-ready">Report Ready</MenuItem>
                <MenuItem value="report-packed">Report Packed</MenuItem>
                <MenuItem value="report-dispatched">Report Dispatched</MenuItem>
                <MenuItem value="report-delivered">Report Delivered</MenuItem>
                <MenuItem value="closed">Closed</MenuItem>
                <MenuItem value="cancelled">Cancelled</MenuItem>
                <MenuItem value="rescheduled">Rescheduled</MenuItem>
              </Select>
            </FormControl>
          )}

          {(searchQuery || (activeTab === 0 && (selectedCommunity !=='all'|| statusFilter !== 'all'))) && (
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                setSearchQuery('');
                fetchBookings(1, "");
                setStatusFilter('all');
                setSearchInput('');
                setSelectedCommunity("all")
              }}
              sx={{
                borderColor: '#006D77',
                color: '#006D77',
                textTransform: 'none',
                '&:hover': {
                  borderColor: '#005560',
                  bgcolor: 'rgba(0, 109, 119, 0.04)'
                }
              }}
            >
              Clear Filters
            </Button>
          )}
        </Paper>

        {getFilteredBookings().length === 0 ? (
          <Paper sx={{ p: 8, textAlign: 'center' }}>
            <PackageIcon sx={{ fontSize: 80, color: 'grey.300', mb: 2 }} />
            <Typography variant="h5" fontWeight="bold" color="text.secondary" gutterBottom>
              {activeTab === 1 
                ? 'No Reports Ready for Collection' 
                : searchQuery || statusFilter !== 'all' 
                  ? 'No Bookings Match Your Search' 
                  : 'No Diagnostic Bookings Found'}
            </Typography>
            <Typography color="text.secondary">
              {activeTab === 1
                ? 'There are no bookings with ready reports at the moment.'
                : searchQuery || statusFilter !== 'all'
                  ? 'Try adjusting your search or filter criteria'
                  : 'There are no diagnostic bookings at the moment.'}
            </Typography>
          </Paper>
        ) : viewMode === 'card' ? (
          <Grid container spacing={3}>
            {getFilteredBookings().map((booking) => {
              const status = getStatusConfig(booking.status);
              const reportCount = booking.diagnostic_reports?.length || 0;
              const isNew = isOrderUnseen('diagnostic', booking.booking_id);
              
              return (
                <Grid item xs={12} sm={6} md={4} key={booking.booking_id}>
                <Card
                  sx={{
                    height: 380,
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: 2.5,
                    border: isNew ? "2px solid #f8e7e7" : "1px solid #e2e8f0", 
                    bgcolor: isNew ? "#FEF2F2" : "#fff", 
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 12px 24px rgba(0, 0, 0, 0.08)",
                      borderColor: isNew ? "#f1b4b4" : "#006d77" 
                    }
                  }}
                  onClick={() => handleOpenDialog(booking)}
                >
                    <CardContent sx={{ flex: 1 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                        <Box>
                          <Typography variant="h6" color="#006D77" fontWeight="bold">
                            {booking.booking_id}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {formatDate(booking.created_at)}
                          </Typography>
                        </Box>
                     
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, alignItems: 'flex-end' }}>
                        <Chip icon={status.icon} label={status.label} color={status.color} size="small" />
                        {reportCount > 0 && (
                          <Badge badgeContent={reportCount} color="success">
                            <Chip 
                              icon={<FileTextIcon />} 
                              label="Reports" 
                              size="small"
                              sx={{ bgcolor: '#ECFDF5', color: '#059669' }}
                            />
                          </Badge>
                        )}
                        <PaymentPendingChip
                          order={{
                            order_id: booking.booking_id,
                            user_phone: booking.phone,
                            total_amount: booking.payment?.amount,
                            payment: booking.payment,
                            service_type: 'diagnostic',
                          }}
                          apiFetch={apiRequest}
                          notify={showCustomDialog}
                        />
                      </Box>
                      </Box>

                      <Divider sx={{ my: 2 }} />

                      <List dense disablePadding>
                        <ListItem disablePadding sx={{ mb: 1 }}>
                          <ListItemIcon sx={{ minWidth: 32 }}>
                            <UserIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText
                            primary={booking.name}
                            primaryTypographyProps={{ variant: 'body2', noWrap: true }}
                          />
                        </ListItem>
                        <ListItem disablePadding sx={{ mb: 1 }}>
                          <ListItemIcon sx={{ minWidth: 32 }}>
                            <PhoneIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText
                            primary={booking.phone}
                            primaryTypographyProps={{ variant: 'body2' }}
                          />
                        </ListItem>
                        <ListItem disablePadding>
                          <ListItemIcon sx={{ minWidth: 32 }}>
                            <ActivityIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText
                            primary={booking.service_type}
                            primaryTypographyProps={{ variant: 'body2', noWrap: true, textTransform: 'capitalize' }}
                          />
                        </ListItem>
                      </List>

                      <Divider sx={{ my: 2 }} />

                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" color="text.secondary">Payment</Typography>
                        <Typography variant="h6" color="#006D77" fontWeight="bold">
                          ₹{booking.payment?.amount?.toFixed(2) || '0.00'}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: '#006D77' }}>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Booking ID</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Patient</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Contact</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Service</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Date</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Status</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Reports</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Payment</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getFilteredBookings().map((booking) => {
                  const status = getStatusConfig(booking.status);
                  const reportCount = booking.diagnostic_reports?.length || 0;
                   const isNew = isOrderUnseen('diagnostic', booking.booking_id);
                  
                  return (
                    <TableRow 
                      key={booking.booking_id}
                      hover
                      sx={{ bgcolor: isNew ? "#FEF2F2" : "inherit", '&:hover': { bgcolor: isNew ? "#FEE2E2" : 'rgba(0, 109, 119, 0.04)' } }}> 
                    
                      <TableCell>
                        <Typography variant="body2" fontWeight="bold" color="#006D77">
                          {booking.booking_id}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <UserIcon fontSize="small" color="action" />
                          <Box>
                            <Typography variant="body2">{booking.name}</Typography>
                            <Typography variant="caption" color="text.secondary">{booking.email}</Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>{booking.phone}</TableCell>
                      <TableCell sx={{ textTransform: 'capitalize' }}>{booking.service_type}</TableCell>
                      <TableCell>{formatDate(booking.date)}</TableCell>
                      <TableCell>
                        <Chip icon={status.icon} label={status.label} color={status.color} size="small" />
                      </TableCell>
                      <TableCell>
                        {reportCount > 0 ? (
                          <Chip 
                            icon={<FileTextIcon />}
                            label={`${reportCount} Report${reportCount > 1 ? 's' : ''}`}
                            size="small"
                            sx={{ bgcolor: '#ECFDF5', color: '#059669', fontWeight: 600 }}
                          />
                        ) : (
                          <Typography variant="caption" color="text.secondary">No reports</Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight="bold" color="#006D77">
                          ₹{booking.payment?.amount?.toFixed(2) || '0.00'}
                        </Typography>
                        <PaymentPendingChip
                          order={{
                            order_id: booking.booking_id,
                            user_phone: booking.phone,
                            total_amount: booking.payment?.amount,
                            payment: booking.payment,
                            service_type: 'diagnostic',
                          }}
                          apiFetch={apiRequest}
                          notify={showCustomDialog}
                        />
                      </TableCell>
                      <TableCell>
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<EyeIcon />}
                          onClick={() => handleOpenDialog(booking)}
                          sx={{
                            borderColor: '#006D77',
                            color: '#006D77',
                            '&:hover': {
                              borderColor: '#005761',
                              bgcolor: 'rgba(0, 109, 119, 0.08)'
                            }
                          }}
                        >
                          View
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
{getFilteredBookings().length > 0 &&(
 <Box display="flex" justifyContent="center" mt={3}>
  <Pagination
    count={activeTab === 1 ? reportReadyCount: totalPages}
    page={page}
    onChange={(e, value) => handlePageChange(value)}
    color="primary"
  />
</Box>)}
      </Container>

      {/* Main Details Dialog - (keeping the rest of your existing dialog code unchanged) */}
      <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth scroll="paper">
        {selectedOrder && (
          <>
            <DialogTitle sx={{ bgcolor: '#006D77', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box>
                <Typography variant="h5" fontWeight="bold">{selectedOrder.booking_id}</Typography>
                {/* <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                  <Chip icon={statusConfig.icon} label={statusConfig.label} color={statusConfig.color} size="small" sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
                  {paymentStatusConfig && (
                    <Chip label={`Payment: ${paymentStatusConfig.label}`} color={paymentStatusConfig.color} size="small" sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
                  )}
                </Box> */}
                <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
  <Chip icon={statusConfig.icon} label={statusConfig.label} color={statusConfig.color} size="small" sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
  {paymentStatusConfig && (
    <Chip label={`Payment: ${paymentStatusConfig.label}`} color={paymentStatusConfig.color} size="small" sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
  )}
  <PaymentPendingChip
    order={{
      order_id: selectedOrder.booking_id,
      user_phone: selectedOrder.phone,
      total_amount: selectedOrder.payment?.amount,
      payment: selectedOrder.payment,
      service_type: 'diagnostic',
    }}
    apiFetch={apiRequest}
    notify={showCustomDialog}
  />
</Box>
              </Box>
              <IconButton onClick={handleCloseDialog} sx={{ color: 'white' }}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent dividers>
              <Box sx={{ py: 2, display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1,color: '#006D77' }}>
                          {selectedOrder.order_from}<br/>
                          Appointment booked for: {formatDate(selectedOrder.date)}
                        </Typography>
                {/* ─── Patient Information — EDITABLE ─────────────────────────────────── */}
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                    <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <UserIcon sx={{ color: '#006D77' }} />Patient Information
                    </Typography>
                    {!editingPatient ? (
                      <Button size="small" variant="outlined" startIcon={<EditIcon />} onClick={handleStartEditPatient}
                        sx={{ textTransform: 'none', borderColor: '#006D77', color: '#006D77', '&:hover': { bgcolor: 'rgba(0,109,119,0.06)', borderColor: '#005560' } }}>
                        Edit
                      </Button>
                    ) : (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button size="small" variant="outlined" startIcon={<CloseIcon />} onClick={handleCancelEditPatient} disabled={savingPatient}
                          sx={{ textTransform: 'none', borderColor: '#9E9E9E', color: '#616161' }}>
                          Cancel
                        </Button>
                        <Button size="small" variant="contained" startIcon={savingPatient ? <CircularProgress size={14} color="inherit" /> : <SaveIcon />} onClick={handleSavePatient} disabled={savingPatient}
                          sx={{ textTransform: 'none', bgcolor: '#006D77', '&:hover': { bgcolor: '#005560' } }}>
                          {savingPatient ? 'Saving…' : 'Save'}
                        </Button>
                      </Box>
                    )}
                  </Box>

                  {!editingPatient ? (
                    /* READ VIEW */
                    <Grid container spacing={2}>
                      <Grid item xs={6}><Typography variant="caption" color="text.secondary">Name</Typography><Typography variant="body1" fontWeight="600">{selectedOrder.name || 'N/A'}</Typography></Grid>
                      <Grid item xs={6}><Typography variant="caption" color="text.secondary">Email</Typography><Typography variant="body1" fontWeight="600">{selectedOrder.email || 'N/A'}</Typography></Grid>
                      <Grid item xs={4}><Typography variant="caption" color="text.secondary">Phone</Typography><Typography variant="body1" fontWeight="600">{selectedOrder.phone || 'N/A'}</Typography></Grid>
                      <Grid item xs={4}><Typography variant="caption" color="text.secondary">Age</Typography><Typography variant="body1" fontWeight="600">{selectedOrder.age || 'N/A'}</Typography></Grid>
                      <Grid item xs={4}><Typography variant="caption" color="text.secondary">Gender</Typography><Typography variant="body1" fontWeight="600" sx={{ textTransform: 'capitalize' }}>{selectedOrder.gender || 'N/A'}</Typography></Grid>
                    </Grid>
                  ) : (
                    /* EDIT VIEW */
                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                      <Grid item xs={12} sm={6}>
                        <TextField label="Name" fullWidth size="small" value={patientForm.name} onChange={e => setPatientForm(f => ({ ...f, name: e.target.value }))} sx={{ '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#006D77' } }, '& .MuiInputLabel-root.Mui-focused': { color: '#006D77' } }} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField label="Email" fullWidth size="small" type="email" value={patientForm.email} onChange={e => setPatientForm(f => ({ ...f, email: e.target.value }))} sx={{ '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#006D77' } }, '& .MuiInputLabel-root.Mui-focused': { color: '#006D77' } }} />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField label="Phone" fullWidth size="small" value={patientForm.phone} onChange={e => setPatientForm(f => ({ ...f, phone: e.target.value }))} sx={{ '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#006D77' } }, '& .MuiInputLabel-root.Mui-focused': { color: '#006D77' } }} />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField label="Age" fullWidth size="small" value={patientForm.age} onChange={e => setPatientForm(f => ({ ...f, age: e.target.value }))} sx={{ '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#006D77' } }, '& .MuiInputLabel-root.Mui-focused': { color: '#006D77' } }} />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl fullWidth size="small">
                          <InputLabel sx={{ '&.Mui-focused': { color: '#006D77' } }}>Gender</InputLabel>
                          <Select label="Gender" value={patientForm.gender} onChange={e => setPatientForm(f => ({ ...f, gender: e.target.value }))} sx={{ '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#006D77' } }}>
                            <MenuItem value="">Not specified</MenuItem>
                            <MenuItem value="male">Male</MenuItem>
                            <MenuItem value="female">Female</MenuItem>
                            <MenuItem value="other">Other</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  )}
                </Paper>

                {selectedOrder.diagnostic_tests && (
                   <Box mt={1}>
                     <Typography variant="body2" fontWeight={600} color="textSecondary">
                       Diagnostic Tests
                     </Typography>
                     <Paper variant="outlined" sx={{ p: 1.5, mt: 0.5, borderRadius: 1.5 }}>
                       <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                         {selectedOrder.diagnostic_tests}
                       </Typography>
                     </Paper>
                   </Box>
                 )}

                {/* Diagnostic Reports Section */}
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <FileTextIcon sx={{ color: '#006D77' }} />
                    Diagnostic Reports
                    {selectedOrder.diagnostic_reports && selectedOrder.diagnostic_reports.length > 0 && (
                      <Chip 
                        label={`${selectedOrder.diagnostic_reports.length} Report${selectedOrder.diagnostic_reports.length > 1 ? 's' : ''}`}
                        size="small"
                        sx={{ bgcolor: '#ECFDF5', color: '#059669', fontWeight: 700, ml: 1 }}
                      />
                    )}
                  </Typography>
                  
                  {/* Upload Section */}
                  <Box sx={{ mb: 3, p: 2, bgcolor: '#F0F9FF', borderRadius: 2 }}>
                    <Typography variant="subtitle2" fontWeight="600" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <UploadIcon />
                      Upload New Report
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<UploadIcon />}
                        sx={{
                          borderColor: '#006D77',
                          color: '#006D77',
                          '&:hover': {
                            borderColor: '#005761',
                            bgcolor: 'rgba(0, 109, 119, 0.08)'
                          }
                        }}
                      >
                        Choose File
                        <input
                          type="file"
                          hidden
                          accept=".png,.jpg,.jpeg,.pdf,.doc,.docx"
                          multiple
                          onChange={handleFileSelect}
                        />
                      </Button>
                                      
                  {Array.isArray(selectedFile) && selectedFile.length > 0 && (  <>
                      <Box sx={{ flex: 1, minWidth: 200 }}>
                        {selectedFile.map((file, idx) => (
                          <Box key={idx} sx={{ mb: 1 }}>
                            <Typography variant="body2" fontWeight="600" noWrap>
                              {file.name}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {(file.size / 1024 / 1024).toFixed(2)} MB
                            </Typography>
                          </Box>
                        ))}
                      </Box>

                      <Button
                        variant="contained"
                        startIcon={
                          uploading ? (
                            <CircularProgress size={20} sx={{ color: 'white' }} />
                          ) : (
                            <UploadIcon />
                          )
                        }
                        onClick={handleUploadReport}
                        disabled={uploading}
                        sx={{
                          bgcolor: '#006D77',
                          '&:hover': { bgcolor: '#005761' }
                        }}
                      >
                        {uploading ? 'Uploading...' : 'Upload'}
                      </Button>
                    </>
                  )}
                  </Box>
                  {Array.isArray(filePreviewUrl) && filePreviewUrl.length > 0 && (
                      <Box sx={{ mt: 2, textAlign: 'center' }}>
                      {filePreviewUrl.map((url, idx) =>
                        url ? (
                          <img
                            key={idx}
                            src={url}
                            alt="Preview"
                            style={{
                              maxWidth: '100%',
                              maxHeight: '200px',
                              borderRadius: '8px',
                              border: '2px solid #E5E7EB',
                              margin: '8px'
                            }}
                          />
                        ) : null
                      )}
                    </Box>
                  )}

              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                      Accepted formats: PNG, JPG, PDF, (Max 10MB)
                    </Typography>
                  </Box>

                  {/* Existing Reports Grid */}
                  {selectedOrder.diagnostic_reports && selectedOrder.diagnostic_reports.length > 0 ? (
                    <Grid container spacing={2}>
                      {selectedOrder.diagnostic_reports.map((report, idx) => {
                        const filename = report?.filename || '';
                        const originalFilename = report?.original_filename || report?.filename || `report_${idx}`;
                        const uploadedAt = report?.uploaded_at;
                        const fileIcon = getFileIcon(originalFilename);
                        
                        return (
                          <Grid item xs={12} sm={6} md={4} key={idx}>
                            <Card
                              sx={{
                                border: '2px solid #E5E7EB',
                                borderRadius: 2,
                                transition: 'all 0.2s',
                                '&:hover': {
                                  borderColor: '#006D77',
                                  boxShadow: '0 4px 12px rgba(0,109,119,0.15)'
                                }
                              }}
                            >
                              <CardContent sx={{ p: 2 }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                  {fileIcon}
                                  <Typography 
                                    variant="body2" 
                                    fontWeight="600" 
                                    sx={{ mt: 1, mb: 0.5 }}
                                    noWrap
                                    title={originalFilename}
                                  >
                                    {originalFilename.length > 20 
                                      ? `${originalFilename.substring(0, 20)}...` 
                                      : originalFilename}
                                  </Typography>
                                  {uploadedAt && (
                                    <Typography variant="caption" color="text.secondary" sx={{ mb: 2 }}>
                                      {formatDate(uploadedAt)}
                                    </Typography>
                                  )}
                                  <Stack direction="row" spacing={1}>
                                    <IconButton
                                      size="small"
                                      sx={{ 
                                        bgcolor: '#DBEAFE', 
                                        '&:hover': { bgcolor: '#BFDBFE' }
                                      }}
                                      onClick={() => handlePreviewFile(selectedOrder.booking_id, report)}
                                      title="Preview"
                                      disabled={!report?.cloudfront_url && !report?.path}
                                    >
                                      <EyeIcon fontSize="small" sx={{ color: '#2563EB' }} />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      sx={{ 
                                        bgcolor: '#D1FAE5', 
                                        '&:hover': { bgcolor: '#A7F3D0' }
                                      }}
                                      onClick={() => handleDownloadReport(selectedOrder.booking_id, filename)}
                                      title="Download"
                                      disabled={!filename}
                                    >
                                      <DownloadIcon fontSize="small" sx={{ color: '#059669' }} />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      sx={{ 
                                        bgcolor: '#FEE2E2', 
                                        '&:hover': { bgcolor: '#FECACA' }
                                      }}
                                      onClick={() => handleDeleteReport(selectedOrder.booking_id, filename)}
                                      title="Delete"
                                      disabled={!filename}
                                    >
                                      <DeleteIcon fontSize="small" sx={{ color: '#DC2626' }} />
                                    </IconButton>
                                  </Stack>
                                </Box>
                              </CardContent>
                            </Card>
                          </Grid>
                        );
                      })}
                    </Grid>
                  ) : (
                    <Box sx={{ textAlign: 'center', py: 4, bgcolor: '#F9FAFB', borderRadius: 2 }}>
                      <FileTextIcon sx={{ fontSize: 64, color: 'grey.300', mb: 1 }} />
                      <Typography variant="body2" color="text.secondary" fontWeight="600">
                        No diagnostic reports uploaded yet
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Upload reports using the button above
                      </Typography>
                    </Box>
                  )}
                </Paper>


                {selectedOrder.payment && (() => {
                  const txHistory = selectedOrder.payment.transaction_history || [];
                  const lastTx = txHistory[txHistory.length - 1];

                  return (
                    <Paper variant="outlined" sx={{ p: 0, overflow: 'hidden' }}>
                      {/* Header */}
                      <Box sx={{ px: 2.5, py: 1.5, bgcolor: '#006D77', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <PaymentIcon sx={{ color: 'white', fontSize: 20 }} />
                        <Typography variant="subtitle1" fontWeight="bold" color="white">
                          Payment Details
                        </Typography>
                      </Box>

                      <Box sx={{ p: 2.5, display: 'flex', flexDirection: 'column', gap: 2.5 }}>

                        {/* ── Section 1: Payment Summary ── */}
                        <Box>
                          <Typography variant="caption" fontWeight="700" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8 }}>
                            Payment Summary
                          </Typography>
                          <Divider sx={{ mt: 0.5, mb: 1.5 }} />
                          <Grid container spacing={2}>
                            <Grid item xs={6} sm={3}>
                              <Typography variant="caption" color="text.secondary">Amount Paid</Typography>
                              <Typography variant="h6" color="#006D77" fontWeight="bold">
                                ₹{typeof selectedOrder.payment.amount === 'number'
                                  ? selectedOrder.payment.amount.toFixed(2)
                                  : parseFloat(selectedOrder.payment.amount || 0).toFixed(2)}
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                              <Typography variant="caption" color="text.secondary">Payment Status</Typography>
                              <Box sx={{ mt: 0.5 }}>
                                <Chip
                                  label={selectedOrder.payment.status || 'N/A'}
                                  color={getPaymentStatusConfig(selectedOrder.payment.status).color}
                                  size="small"
                                  sx={{ fontWeight: 700 }}
                                />
                              </Box>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                              <Typography variant="caption" color="text.secondary">Payment Mode</Typography>
                              <Typography variant="body2" fontWeight="600" sx={{ textTransform: 'capitalize', mt: 0.5 }}>
                                {selectedOrder.payment.method || 'N/A'}
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                              <Typography variant="caption" color="text.secondary">Payment ID</Typography>
                              <Typography variant="body2" fontWeight="600" sx={{ fontFamily: 'monospace', mt: 0.5, wordBreak: 'break-all' }}>
                                {selectedOrder.payment.payment_id || 'N/A'}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>

                        {/* ── Section 2: Last Transaction ── */}
                        {lastTx ? (
                          <Box>
                            <Typography variant="caption" fontWeight="700" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8 }}>
                              Last Transaction
                            </Typography>
                            <Divider sx={{ mt: 0.5, mb: 1.5 }} />
                            <Box sx={{ bgcolor: '#F8FAFC', borderRadius: 2, border: '1px solid #E2E8F0', p: 2 }}>
                              <Grid container spacing={2}>

                                <Grid item xs={6} sm={4}>
                                  <Typography variant="caption" color="text.secondary">Transaction Status</Typography>
                                  <Box sx={{ mt: 0.5 }}>
                                    <Chip
                                      label={lastTx.status || 'N/A'}
                                      color={getPaymentStatusConfig(lastTx.status).color}
                                      size="small"
                                      sx={{ fontWeight: 700 }}
                                    />
                                  </Box>
                                </Grid>
                                <Grid item xs={6} sm={4}>
                                  <Typography variant="caption" color="text.secondary">Transaction Amount</Typography>
                                  <Typography variant="body1" fontWeight="700" color="#006D77" sx={{ mt: 0.5 }}>
                                    ₹{typeof lastTx.amount === 'number'
                                      ? lastTx.amount.toFixed(2)
                                      : parseFloat(lastTx.amount || 0).toFixed(2)}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} sm={4}>
                                  <Typography variant="caption" color="text.secondary">Payment Method</Typography>
                                  <Typography variant="body2" fontWeight="600" sx={{ textTransform: 'capitalize', mt: 0.5 }}>
                                    {lastTx.method || 'N/A'}
                                  </Typography>
                                </Grid>

                                <Grid item xs={6} sm={4}>
                                  <Typography variant="caption" color="text.secondary">Transaction Time</Typography>
                                  <Typography variant="body2" fontWeight="600" sx={{ mt: 0.5 }}>
                                    {lastTx.timestamp
                                      ? new Date(lastTx.timestamp).toLocaleString('en-IN', {
                                          day: '2-digit',
                                          month: 'short',
                                          year: 'numeric',
                                          hour: '2-digit',
                                          minute: '2-digit',
                                        })
                                      : 'N/A'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                                {selectedOrder.diagnostic_reports.length>0 &&(<Button
                                    variant="contained"
                                    onClick={() => sendDiagnosticReportOnWhatsapp()}
                                    startIcon={<WhatsAppIcon />}
                                     sx={{ 
                                      bgcolor: '#25D366', 
                                      color:'#ffffff',
                                      '&:hover': { bgcolor: '#005560',color:'#ffffff' },
                                      textTransform: 'none'
                                    }}
                                  >
                                    Send Report on WhatsApp
                                  </Button>)}
                                  <Button
                                    variant="contained"
                                    startIcon={<DownloadIcon />}
                                    onClick={() => {
                                      handleInvoiceDownload(selectedOrder.booking_id)
                                    }}
                                    sx={{ 
                                      bgcolor: '#006D77', 
                                      '&:hover': { bgcolor: '#005560' },
                                      textTransform: 'none'
                                    }}
                                  >
                                    Download Invoice
                                  </Button>
                                  
                                </Box>
                          </Box>
                        ) : (
                          <Box sx={{ textAlign: 'center', py: 2, bgcolor: '#F9FAFB', borderRadius: 2 }}>
                            <Typography variant="body2" color="text.secondary">No transaction history available</Typography>
                          </Box>
                        )}
                      </Box>
                    </Paper>
                  );
                })()}

                {/* Discount & Savings Section */}
                {(selectedOrder.subscription_discount > 0 || selectedOrder.promo_discount > 0) && (
                  <Paper variant="outlined" sx={{ p: 2, bgcolor: '#F0FDF4', borderColor: '#86EFAC' }}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#059669' }}>
                      <CheckCircleIcon sx={{ color: '#059669' }} />
                      Discounts Applied
                    </Typography>
                    <Grid container spacing={2}>
                      {selectedOrder.subscription_discount > 0 && (
                        <Grid item xs={12}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1.5, bgcolor: 'white', borderRadius: 1, border: '1px solid #D1FAE5' }}>
                            <Box>
                              <Typography variant="body2" fontWeight="600" color="text.primary">
                                Subscription Discount
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                Member savings applied
                              </Typography>
                            </Box>
                            <Typography variant="h6" color="#059669" fontWeight="bold">
                              -₹{selectedOrder.subscription_discount?.toFixed(2)}
                            </Typography>
                          </Box>
                        </Grid>
                      )}
                      {selectedOrder.promo_discount > 0 && (
                        <Grid item xs={12}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1.5, bgcolor: 'white', borderRadius: 1, border: '1px solid #D1FAE5' }}>
                            <Box>
                              <Typography variant="body2" fontWeight="600" color="text.primary">
                                Promo Code Discount
                              </Typography>
                              {selectedOrder.promo_code && (
                                <Chip 
                                  label={selectedOrder.promo_code} 
                                  size="small" 
                                  sx={{ mt: 0.5, bgcolor: '#FEF3C7', color: '#D97706', fontWeight: 700 }}
                                />
                              )}
                            </Box>
                            <Typography variant="h6" color="#059669" fontWeight="bold">
                              -₹{selectedOrder.promo_discount?.toFixed(2)}
                            </Typography>
                          </Box>
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <Divider sx={{ my: 1 }} />
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1 }}>
                          <Typography variant="body1" fontWeight="700" color="#059669">
                            Total Savings
                          </Typography>
                          <Typography variant="h5" color="#059669" fontWeight="bold">
                            ₹{((selectedOrder.subscription_discount || 0) + (selectedOrder.promo_discount || 0)).toFixed(2)}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Paper>
                )}



        {/* Sample Collection Agent */}
        {selectedOrder?.assigned_agent_id ? (
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PersonIcon sx={{ color: '#006D77' }} />
              Assigned Sample Collection Agent
            </Typography>

            {loadingAgent ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                <CircularProgress size={40} sx={{ color: '#006D77' }} />
              </Box>
            ) : agentDetails ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Agent ID</Typography>
                  <Typography variant="body2" fontWeight="600">{agentDetails.agentId || '—'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Name</Typography>
                  <Typography variant="body2" fontWeight="600">{agentDetails.name || '—'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Phone</Typography>
                  <Typography variant="body2" fontWeight="600">{agentDetails.phone || '—'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Email</Typography>
                  <Typography variant="body2" fontWeight="600">{agentDetails.email || '—'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Employee ID</Typography>
                  <Typography variant="body2" fontWeight="600">{agentDetails.employeeId || '—'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Role</Typography>
                  <Chip
                    label={agentDetails.agentRole === 'delivery' ? 'Delivery Agent' : 'Sample Collection'}
                    size="small"
                    sx={{
                      bgcolor: agentDetails.agentRole === 'delivery' ? '#D1FAE5' : '#DBEAFE',
                      color: agentDetails.agentRole === 'delivery' ? '#059669' : '#2563EB',
                      fontWeight: 600, fontSize: '0.7rem'
                    }}
                  />
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Vehicle No</Typography>
                  <Typography variant="body2" fontWeight="600">{agentDetails.vehicleNumber || '—'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Status</Typography>
                  <Chip
                    label={agentDetails.isActive ? 'Active' : 'Inactive'}
                    size="small"
                    sx={{
                      bgcolor: agentDetails.isActive ? '#D1FAE5' : '#FEE2E2',
                      color: agentDetails.isActive ? '#059669' : '#DC2626',
                      fontWeight: 600, fontSize: '0.7rem'
                    }}
                  />
                </Box>
                {agentDetails.address && (
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Address</Typography>
                    <Typography variant="body2" fontWeight="600">
                      {[
                        agentDetails.address.street,
                        agentDetails.address.city,
                        agentDetails.address.state && agentDetails.address.pincode
                          ? `${agentDetails.address.state} - ${agentDetails.address.pincode}`
                          : agentDetails.address.state
                      ].filter(Boolean).join(', ')}
                    </Typography>
                  </Box>
                )}
              </Box>
            ) : (
              <Typography sx={{ color: '#D97706', textAlign: 'center', py: 2 }}>
                ⚠️ Agent details not available
              </Typography>
            )}
          </Paper>
        ) : (
          <Paper variant="outlined" sx={{ p: 2, bgcolor: '#f8fafc' }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PersonIcon sx={{ color: '#94a3b8' }} />
              Sample Collection Agent
            </Typography>
            <Typography sx={{ color: '#64748b', textAlign: 'center', py: 2 }}>
              No sample collection agent assigned yet
            </Typography>
          </Paper>
        )}

        {/* Report Delivery Agent */}
        {selectedOrder?.report_delivery_agent_id ? (
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PersonIcon sx={{ color: '#006D77' }} />
              Assigned Report Delivery Agent
            </Typography>

            {loadingReportAgent ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                <CircularProgress size={40} sx={{ color: '#006D77' }} />
              </Box>
            ) : reportDeliveryAgentDetails ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Agent ID</Typography>
                  <Typography variant="body2" fontWeight="600">{reportDeliveryAgentDetails.agentId || '—'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Name</Typography>
                  <Typography variant="body2" fontWeight="600">{reportDeliveryAgentDetails.name || '—'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Phone</Typography>
                  <Typography variant="body2" fontWeight="600">{reportDeliveryAgentDetails.phone || '—'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Email</Typography>
                  <Typography variant="body2" fontWeight="600">{reportDeliveryAgentDetails.email || '—'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Employee ID</Typography>
                  <Typography variant="body2" fontWeight="600">{reportDeliveryAgentDetails.employeeId || '—'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Role</Typography>
                  <Chip
                    label="Report Delivery"
                    size="small"
                    sx={{ bgcolor: '#DBEAFE', color: '#2563EB', fontWeight: 600, fontSize: '0.7rem' }}
                  />
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Vehicle No</Typography>
                  <Typography variant="body2" fontWeight="600">{reportDeliveryAgentDetails.vehicleNumber || '—'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Status</Typography>
                  <Chip
                    label={reportDeliveryAgentDetails.isActive ? 'Active' : 'Inactive'}
                    size="small"
                    sx={{
                      bgcolor: reportDeliveryAgentDetails.isActive ? '#D1FAE5' : '#FEE2E2',
                      color: reportDeliveryAgentDetails.isActive ? '#059669' : '#DC2626',
                      fontWeight: 600, fontSize: '0.7rem'
                    }}
                  />
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Assignment Status</Typography>
                  <Chip
                    label={selectedOrder.report_delivery_assignment_status || 'pending'}
                    size="small"
                    color={
                      selectedOrder.report_delivery_assignment_status === 'accepted' ? 'success' :
                      selectedOrder.report_delivery_assignment_status === 'rejected' ? 'error' : 'warning'
                    }
                    sx={{ fontWeight: 600, fontSize: '0.7rem' }}
                  />
                </Box>
                {reportDeliveryAgentDetails.address && (
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120 }}>Address</Typography>
                    <Typography variant="body2" fontWeight="600">
                      {[
                        reportDeliveryAgentDetails.address.street,
                        reportDeliveryAgentDetails.address.city,
                        reportDeliveryAgentDetails.address.state && reportDeliveryAgentDetails.address.pincode
                          ? `${reportDeliveryAgentDetails.address.state} - ${reportDeliveryAgentDetails.address.pincode}`
                          : reportDeliveryAgentDetails.address.state
                      ].filter(Boolean).join(', ')}
                    </Typography>
                  </Box>
                )}
              </Box>
            ) : (
              <Typography sx={{ color: '#D97706', textAlign: 'center', py: 2 }}>
                ⚠️ Report delivery agent details not available
              </Typography>
            )}
          </Paper>
        ) : selectedOrder?.status === 'report-dispatched' && (
          <Paper variant="outlined" sx={{ p: 2, bgcolor: '#f8fafc' }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PersonIcon sx={{ color: '#94a3b8' }} />
              Report Delivery Agent
            </Typography>
            <Typography sx={{ color: '#64748b', textAlign: 'center', py: 2 }}>
              No report delivery agent assigned yet
            </Typography>
          </Paper>
        )}








{(() => {
const combinedIssues = getCombinedIssues(selectedOrder);
  if (combinedIssues.length === 0) return null;
  return (
  <Paper variant="outlined" sx={{ p: 2 }}>
      {/* Header Section */}
      <Box 
      sx={{ p: 2.5, color: 'blqack',display: 'flex',justifyContent: 'space-between',alignItems: 'center',cursor: 'pointer'}}

        onClick={() => {
          // Toggle all issues expansion state
          const allIssueIds = combinedIssues.map(i => i.issue_id);
          const allExpanded = allIssueIds.every(id => expandedIssues[id]);
          const newExpandedState = {};
          allIssueIds.forEach(id => {
            newExpandedState[id] = !allExpanded;
          });
          setExpandedIssues(newExpandedState);
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
         <Box  sx={{ width: 48, height: 48, borderRadius: '50%', bgcolor: 'rgba(255,255,255,0.2)',display: 'flex',alignItems: 'center',justifyContent: 'center' }} >
 
            <DescriptionIcon sx={{ fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="h6" fontWeight="bold">
              Delivery Issues & Collection Failures
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              {combinedIssues.filter(i => i.source === 'delivery_issue').length} Delivery • 
              {/* {' '}{combinedIssues.filter(i => i.source === 'collection_failure').length} Collection • 
              {' '}{combinedIssues.filter(i => i.status === 'open').length} Active */}
            </Typography>
          </Box>
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Chip 
            label={`${combinedIssues.length} Total Issue${combinedIssues.length > 1 ? 's' : ''}`}
            sx={{ bgcolor: '#006D77', color: 'white',fontWeight: 700,fontSize: '0.875rem'}}

          />
        </Box>
      </Box>

      {/* Issues List */}
      <Box sx={{ bgcolor: '#FEFEFE' }}>
        {combinedIssues.map((issue, index) => {
          const isExpanded = expandedIssues[issue.issue_id] || false;
          const issueTypeFormatted = issue.issue_type?.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase()) || 'N/A';
          const isCollectionFailure = issue.source === 'collection_failure';
          
          return (
            <Box 
              key={issue.issue_id || index}
              sx={{ 
                borderBottom: index < combinedIssues.length - 1 ? '1px solid #E5E7EB' : 'none'
              }}
            >
              {/* Collapsible Header */}
              <Box
                onClick={() => setExpandedIssues(prev => ({ ...prev, [issue.issue_id]: !isExpanded }))}
                sx={{p: 2,display: 'flex',justifyContent: 'space-between',alignItems: 'center',cursor: 'pointer',}}

              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
                  {/* Status Indicator */}
                  <Box
                  sx={{width: 8,height: 8,borderRadius: '50%',bgcolor:  '#006D77',boxShadow: `0 0 0 3px ${'#D1EEF0'}`}}

                  />
                  
                  {/* Issue Info */}
                  <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5, flexWrap: 'wrap' }}>
                      <Typography variant="body1" fontWeight="700" color="#1F2937">
                        {issue.issue_id}
                      </Typography>
                      
                      {/* Issue Category Badge */}
                      <Chip 
                        label={issue.issue_category}
                        size="small"
                        sx={{  bgcolor: isCollectionFailure ? '#DBEAFE' : '#FEE2E2',color: isCollectionFailure ? '#1E40AF' : '#991B1B',fontWeight: 600,fontSize: '0.70rem',height: 20
                        }}
                      />
                      
                      {/* Issue Type Badge */}
                      <Chip 
                        label={issueTypeFormatted}
                        size="small"
                        sx={{ bgcolor: '#F3F4F6',color: '#374151',fontWeight: 600,fontSize: '0.70rem',height: 20 }}
                      />
                      
                      {/* Status Chip */}
                      <Chip 
                        label={issue.status === 'resolved' ? 'Resolved' : issue.status === 'in_progress' ? 'In Progress' : 'Open'}
                        size="small"
                        color={
                          issue.status === 'resolved' ? 'success' :
                          issue.status === 'in_progress' ? 'warning' :
                          'error'
                        }
                        sx={{ 
                          fontWeight: 600,
                          fontSize: '0.70rem',
                          height: 20
                        }}
                      />
                    </Box>
                    <Typography variant="caption" color="text.secondary">
                      Reported {formatDate(issue.reported_at)} • By {issue.reported_by || 'Unknown'}
                    </Typography>
                  </Box>
                </Box>

                {/* Expand Icon */}
                <IconButton 
                  size="small"
                  sx={{  color: '#6B7280', transition: 'transform 0.2s', transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
                >
                  <CloseIcon sx={{ transform: isExpanded ? 'rotate(45deg)' : 'rotate(0deg)' }} />
                </IconButton>
              </Box>

              {/* Expandable Content */}
              <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                <Box sx={{ p: 3, bgcolor: '#F9FAFB', borderTop: '1px solid #E5E7EB' }}>
                  <Grid container spacing={3}>
                    {/* Description */}
                    <Grid item xs={12}>
                      <Box>
                        <Typography variant="subtitle2" fontWeight="700" color="#374151" gutterBottom>
                          {isCollectionFailure ? 'Failure Details' : 'Issue Description'}
                        </Typography>
                        <Paper 
                          variant="outlined"
                          sx={{ 
                            p: 2, 
                            bgcolor: 'white',
                            borderColor: '#E5E7EB'
                          }}
                        >
                          <Typography variant="body2" color="#4B5563" sx={{ lineHeight: 1.6 }}>
                            {issue.description || 'No description provided'}
                          </Typography>
                        </Paper>
                      </Box>
                    </Grid>

                    {/* Photo Evidence */}
                    {issue.photo_url && (
                      <Grid item xs={12} md={6}>
                        <Box>
                          <Typography variant="subtitle2" fontWeight="700" color="#374151" gutterBottom>
                            Photo Evidence
                          </Typography>
                          <Paper
                            elevation={2}
                            sx={{
                              position: 'relative',
                              overflow: 'hidden',
                              borderRadius: 2,
                              cursor: 'pointer',
                              transition: 'all 0.3s',
                              '&:hover': {
                                transform: 'scale(1.02)',
                                boxShadow: 6
                              }
                            }}
                            onClick={() => window.open(`${process.env.REACT_APP_BACKEND_URL}${issue.photo_url}`, '_blank')}
                          >
                            <Box
                              component="img"
                              src={`${process.env.REACT_APP_BACKEND_URL}${issue.photo_url}`}
                              alt="Issue evidence"
                              sx={{
                                width: '100%',
                                height: 250,
                                objectFit: 'cover'
                              }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                            <Box
                              sx={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                bgcolor: 'rgba(0,0,0,0.6)',
                                color: 'white',
                                p: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 0.5
                              }}
                            >
                              <Typography variant="caption" fontWeight="600">
                                Click to view full size
                              </Typography>
                            </Box>
                          </Paper>
                        </Box>
                      </Grid>
                    )}

                    {/* Issue Details */}
                    <Grid item xs={12} md={issue.photo_url ? 6 : 12}>
                      <Box>
                        <Typography variant="subtitle2" fontWeight="700" color="#374151" gutterBottom>
                          {isCollectionFailure ? 'Collection Failure Details' : 'Issue Details'}
                        </Typography>
                        <Paper variant="outlined" sx={{ bgcolor: 'white', borderColor: '#E5E7EB' }}>
                          <List dense disablePadding>
                            <ListItem divider>
                              <ListItemText 
                                primary={<Typography variant="caption" color="text.secondary">ID</Typography>}
                                secondary={<Typography variant="body2" fontWeight="600">{issue.issue_id}</Typography>}
                              />
                            </ListItem>
                            <ListItem divider>
                              <ListItemText 
                                primary={<Typography variant="caption" color="text.secondary">Category</Typography>}
                                secondary={
                                  <Chip 
                                    label={issue.issue_category}
                                    size="small"
                                    sx={{ 
                                      mt: 0.5,
                                      bgcolor: isCollectionFailure ? '#DBEAFE' : '#FEE2E2',
                                      color: isCollectionFailure ? '#1E40AF' : '#991B1B',
                                      fontWeight: 600
                                    }}
                                  />
                                }
                              />
                            </ListItem>
                            <ListItem divider>
                              <ListItemText 
                                primary={<Typography variant="caption" color="text.secondary">Type</Typography>}
                                secondary={<Typography variant="body2" fontWeight="600">{issueTypeFormatted}</Typography>}
                              />
                            </ListItem>
                            <ListItem divider>
                              <ListItemText 
                                primary={<Typography variant="caption" color="text.secondary">Status</Typography>}
                                secondary={
                                  <Chip 
                                    label={issue.status === 'resolved' ? 'Resolved' : issue.status === 'in_progress' ? 'In Progress' : 'Open'}
                                    size="small"
                                    color={
                                      issue.status === 'resolved' ? 'success' :
                                      issue.status === 'in_progress' ? 'warning' :
                                      'error'
                                    }
                                    sx={{ mt: 0.5, fontWeight: 600 }}
                                  />
                                }
                              />
                            </ListItem>
                            <ListItem divider>
                              <ListItemText 
                                primary={<Typography variant="caption" color="text.secondary">Reported By</Typography>}
                                secondary={<Typography variant="body2" fontWeight="600">{issue.reported_by || 'Unknown'}</Typography>}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText 
                                primary={<Typography variant="caption" color="text.secondary">Reported At</Typography>}
                                secondary={<Typography variant="body2" fontWeight="600">{formatDate(issue.reported_at)}</Typography>}
                              />
                            </ListItem>
                          </List>
                        </Paper>
                      </Box>
                    </Grid>

                    {/* Collection Failure Specific Info */}
                    {isCollectionFailure && (issue.can_reschedule || issue.patient_available || issue.address_issue) && (
                      <Grid item xs={12}>
                        <Box>
                          <Typography variant="subtitle2" fontWeight="700" color="#2563EB" gutterBottom>
                            Additional Collection Information
                          </Typography>
                          <Paper variant="outlined" sx={{ bgcolor: '#EFF6FF', borderColor: '#BFDBFE' }}>
                            <List dense disablePadding>
                              {issue.can_reschedule && (
                                <ListItem divider>
                                  <ListItemText 
                                    primary={<Typography variant="caption" color="text.secondary">Can Reschedule</Typography>}
                                    secondary={
                                      <Chip 
                                        label={issue.can_reschedule === 'yes' ? 'Yes' : 'No'}
                                        size="small"
                                        color={issue.can_reschedule === 'yes' ? 'success' : 'error'}
                                        sx={{ mt: 0.5, fontWeight: 600 }}
                                      />
                                    }
                                  />
                                </ListItem>
                              )}
                              {issue.suggested_reschedule_time && (
                                <ListItem divider>
                                  <ListItemText 
                                    primary={<Typography variant="caption" color="text.secondary">Suggested Reschedule Time</Typography>}
                                    secondary={<Typography variant="body2" fontWeight="600">{issue.suggested_reschedule_time}</Typography>}
                                  />
                                </ListItem>
                              )}
                              {issue.patient_available && (
                                <ListItem divider>
                                  <ListItemText 
                                    primary={<Typography variant="caption" color="text.secondary">Patient Available</Typography>}
                                    secondary={<Typography variant="body2" fontWeight="600">{issue.patient_available}</Typography>}
                                  />
                                </ListItem>
                              )}
                              {issue.address_issue && (
                                <ListItem divider>
                                  <ListItemText 
                                    primary={<Typography variant="caption" color="text.secondary">Address Issue</Typography>}
                                    secondary={<Typography variant="body2" fontWeight="600">{issue.address_issue}</Typography>}
                                  />
                                </ListItem>
                              )}
                              {issue.additional_notes && (
                                <ListItem>
                                  <ListItemText 
                                    primary={<Typography variant="caption" color="text.secondary">Additional Notes</Typography>}
                                    secondary={<Typography variant="body2" fontWeight="600">{issue.additional_notes}</Typography>}
                                  />
                                </ListItem>
                              )}
                            </List>
                          </Paper>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Collapse>
            </Box>
          );
        })}
      </Box>

      {/* Footer Summary */}
      <Box 
        sx={{ p: 2, bgcolor: '#F9FAFB',borderTop: '2px solid #E5E7EB',display: 'flex',justifyContent: 'space-between',alignItems: 'center',flexWrap: 'wrap',gap: 2}}
      >
        <Typography variant="body2" color="text.secondary" fontWeight="500">
          Total: {combinedIssues.length} issue{combinedIssues.length !== 1 ? 's' : ''} 
          ({combinedIssues.filter(i => i.source === 'delivery_issue').length} delivery, 
          {' '}{combinedIssues.filter(i => i.source === 'collection_failure').length} collection)
        </Typography>
        <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
          <Chip 
            icon={<DescriptionIcon sx={{ fontSize: 16 }} />}
            label={`${combinedIssues.filter(i => i.status === 'open').length} Open`}
            size="small"
            sx={{ bgcolor: '#FEE2E2',color: '#991B1B',fontWeight: 600}}
          />
        </Box>
      </Box>
    </Paper>
  );
})()}

{(!selectedOrder?.assigned_agent_id && selectedOrder.status=='Confirmed' &&<AssignAgent selectedOrder={selectedOrder} orderType='booking' deliveryType='sample' agentRole='sample_collection'
  onAssignmentSuccess={(data,id) => {
    console.log("Assignment Success:", data);

    // Or update local state
    setSelectedOrder(prev => ({
      ...prev,
      assigned_agent_id:id
    }));
    fetchAgentDetails(id);
  }}

></AssignAgent>)}
{(selectedOrder.status=='report-dispatched' && !selectedOrder.report_delivery_agent_id &&<AssignAgent selectedOrder={selectedOrder} orderType='booking' deliveryType='report' agentRole='delivery' 
onAssignmentSuccess={(data,id) => {
    console.log("Assignment Success:", data);

    // Or update local state
    setSelectedOrder(prev => ({
      ...prev,
      report_delivery_agent_id:id
    }));
    fetchReportDeliveryAgentDetails(id);
  }}
></AssignAgent>)}
               
<Paper variant="outlined" sx={{ p: 2 }}>
  <Typography variant="h6" fontWeight="bold" gutterBottom>
    Update Booking Status
  </Typography>
                {/* Show different buttons based on current status */}
  {selectedOrder.status === 'report-ready' ? (
    // When report is ready, show Pack and Dispatch buttons
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Alert severity="info" sx={{ mb: 1 }}>
        <Typography variant="body2">
          Report is ready. Please pack the report and then dispatch it for delivery.
        </Typography>
      </Alert>
      
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Button
            variant="contained"
            onClick={() => updateBooking(selectedOrder.booking_id, 'status', { status: 'report-packed' })}
            disabled={updating}
            fullWidth
            sx={{
              bgcolor: '#F59E0B',
              color: 'white',
              '&:hover': { bgcolor: '#D97706' }
            }}
          >
            Pack Report
          </Button>
        </Grid>
      </Grid>
    </Box>
  ) : selectedOrder.status === 'report-packed' ? (
    // When packed, show Dispatch button
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Alert severity="success" sx={{ mb: 1 }}>
        <Typography variant="body2">
          Report is packed. Ready to dispatch for delivery.
        </Typography>
      </Alert>
      
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Button
            variant="contained"
            onClick={() => updateBooking(selectedOrder.booking_id, 'status', { status: 'report-dispatched' })}
            disabled={updating}
            fullWidth
            sx={{
              bgcolor: '#10B981',
              color: 'white',
              '&:hover': { bgcolor: '#059669' }
            }}
          >
             Dispatch Report
          </Button>
        </Grid>
      </Grid>
    </Box>
  ) : selectedOrder.status === 'report-dispatched' ? (
    // When dispatched, show info message
    <Alert severity="info">
      <Typography variant="body2" fontWeight="600">
        Report has been dispatched. Awaiting delivery confirmation from agent.
      </Typography>
      {selectedOrder.assigned_agent_id && (
        <Typography variant="caption" display="block" sx={{ mt: 1 }}>
          Assigned to delivery agent for delivery to customer.
        </Typography>
      )}
    </Alert>
  ) : (
    // For all other statuses, show the full status grid
    <Grid container spacing={1}>
      {["new", "Confirmed", "sample-collected", "test-in-progress", "report-ready", "report-packed", "report-dispatched", "report-delivered", "closed", "cancelled"].map((status) => (
        <Grid item xs={6} sm={4} md={3} key={status}>
          <Button
            variant={selectedOrder.status === status ? 'contained' : 'outlined'}
            onClick={() => updateBooking(selectedOrder.booking_id, 'status', { status })}
            disabled={updating || selectedOrder.status === status}
            fullWidth
            size="small"
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderColor: status === 'report-packed' ? '#F59E0B' : status === 'report-dispatched' ? '#10B981' : '#006D77',
              color: selectedOrder.status === status ? '#fff' : (status === 'report-packed' ? '#F59E0B' : status === 'report-dispatched' ? '#10B981' : '#006D77'),
              backgroundColor: selectedOrder.status === status ? 
                (status === 'report-packed' ? '#F59E0B' : status === 'report-dispatched' ? '#10B981' : '#006D77') : 
                'transparent',
              '&:hover': {
                backgroundColor: selectedOrder.status === status ? 
                  (status === 'report-packed' ? '#D97706' : status === 'report-dispatched' ? '#059669' : '#005761') : 
                  'rgba(0, 109, 119, 0.08)',
                borderColor: status === 'report-packed' ? '#F59E0B' : status === 'report-dispatched' ? '#10B981' : '#006D77'
              }
            }}
          >
            {status === 'report-packed' && ' '}
            {status === 'report-dispatched' && ' '}
            {status.replace('-', ' ').split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')}
          </Button>
        </Grid>
      ))}
    </Grid>
  )}
</Paper>

              </Box>
            </DialogContent>

            <DialogActions sx={{ p: 2 }}>
              <Button
                variant="contained"
                color="warning"
                startIcon={<BellIcon />}
                onClick={sendNotification}
                disabled={updating}
                fullWidth
              >
                {updating ? 'Sending...' : 'Send Notification'}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* File Preview Dialog */}
      <Dialog
        open={previewDialogOpen}
        onClose={handleClosePreviewDialog}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ bgcolor: '#006D77', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <FileTextIcon />
            <Typography variant="h6">Report Preview</Typography>
          </Box>
          <IconButton onClick={handleClosePreviewDialog} sx={{ color: 'white' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {previewFile && (
            <Box sx={{ py: 3 }}>
              <Box sx={{ textAlign: 'center', mb: 3 }}>
                <Box sx={{ mb: 2 }}>
                  {getFileIcon(previewFile.original_filename || previewFile.filename)}
                </Box>
                <Typography variant="h6" fontWeight="600" gutterBottom>
                  {previewFile.original_filename || previewFile.filename}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Uploaded: {formatDate(previewFile.uploaded_at)}
                </Typography>
              </Box>

              {previewContent && (
                <Box sx={{ mb: 3, textAlign: 'center' }}>
                  {isImageFile(previewContent.filename) ? (
                    <img 
                      src={previewContent.url} 
                      alt={previewContent.filename}
                      style={{ 
                        maxWidth: '100%', 
                        maxHeight: '500px',
                        borderRadius: '8px',
                        border: '2px solid #E5E7EB'
                      }}
                    />
                  ) : isPdfFile(previewContent.filename) ? (
                    <iframe
                      src={previewContent.url}
                      style={{
                        width: '100%',
                        height: '600px',
                        border: '2px solid #E5E7EB',
                        borderRadius: '8px'
                      }}
                      title="PDF Preview"
                    />
                  ) : (
                    <Paper sx={{ p: 4, bgcolor: '#F9FAFB' }}>
                      <FileIcon sx={{ fontSize: 64, color: 'grey.400', mb: 2 }} />
                      <Typography variant="body1" color="text.secondary">
                        Preview not available for this file type
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Please download the file to view it
                      </Typography>
                    </Paper>
                  )}
                </Box>
              )}

              <Stack direction="row" spacing={2} justifyContent="center">
                <Button
                  variant="contained"
                  startIcon={<DownloadIcon />}
                  onClick={() => handleDownloadReport(previewFile.bookingId, previewFile.filename)}
                  sx={{ bgcolor: '#006D77', '&:hover': { bgcolor: '#005761' } }}
                >
                  Download
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<DeleteIcon />}
                  onClick={() => {
                    handleClosePreviewDialog();
                    handleDeleteReport(previewFile.bookingId, previewFile.filename);
                  }}
                  color="error"
                >
                  Delete
                </Button>
              </Stack>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* Custom Dialog */}
      <CustomDialog
        open={customDialog.show}
        message={customDialog.message}
        title={customDialog.title}
        type={customDialog.type}
        onClose={handleCloseCustomDialog}
        buttonText="OK"
      />
    </Box>
  );
};

export default DiagnosticOrdersScreen;